module.exports = __webpack_public_path__ + "img/process02.caefb107.svg";